import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Footer from "@/components/Footer";
import { toast } from "sonner";

const LOGO = process.env.PUBLIC_URL + "/nextrota-logo.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F6F9FE]">
      <main className="flex-1 grid place-items-center px-6 py-12">
        <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 p-8 sm:p-10 shadow-sm">
          <Link to="/login" className="inline-block mb-6">
            <img src={LOGO} alt="NextRota" className="h-8 w-auto"/>
          </Link>
          <div className="eyebrow mb-2">Forgot password</div>
          <h1 className="font-display text-3xl mb-3 text-[#0B1A36]">Reset your password</h1>
          {!sent ? (
            <>
              <p className="text-[#4B5773] text-sm mb-6">Enter the email associated with your NextRota account and we'll send you a secure reset link. The link expires in 60 minutes.</p>
              <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
                <div>
                  <Label className="text-xs uppercase tracking-widest text-[#4B5773]">Work email</Label>
                  <Input required type="email" value={email} data-testid="forgot-email"
                    onChange={(e)=>setEmail(e.target.value)}
                    className="h-11 mt-2 rounded-lg border-slate-200"/>
                </div>
                <Button type="submit" disabled={busy} data-testid="forgot-submit"
                  className="w-full h-11 rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8]">
                  {busy ? "Sending…" : "Send reset link"}
                </Button>
              </form>
            </>
          ) : (
            <div data-testid="forgot-success" className="space-y-4">
              <p className="text-[#1F2A44] text-sm">If <strong>{email}</strong> is associated with an active NextRota account, a password reset link is on its way. Check your inbox (and spam folder) - the link expires in 60 minutes.</p>
              <p className="text-xs text-[#4B5773]">For security reasons we don't reveal whether an email is registered.</p>
            </div>
          )}
          <p className="text-sm text-[#4B5773] mt-6 text-center">
            <Link to="/login" className="text-[#2563EB] hover:underline" data-testid="back-to-login">← Back to sign in</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
